import React from "react";
import { useEffect, useState } from "react";
import { Collapse } from 'reactstrap';
import RFField from "../../../components/Form/RFField";
import { DatetimePicker } from '../../../commons/controls';
import { useRFFormContext } from "../../../components/Form/RFForm";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../JegyertekesitesTooltips';

const RendelesEloszures = ({
  helyszinValue, helyszinOnChange, helyszinDisabled, helyszinOptions,

  kezdeteValue, vegeValue, datumDisabled, datumOnChange,

  keresesTypeValue, keresesTypeOnChange,
   
  keresesValue, keresesOnChange,

  fizKezdeteValue, fizVegeValue, fizDatumOnChange,

  eloadasValue, handleInputChange, eloadasDisabled, eloadasOptions,

  fizetesiModValue, fizetesiModDisabled, fizetesiModOptions,

  rendelesTipusValue, rendelesTipusDisabled, rendelesTipusOptions,

  rendelesAllapotValue, rendelesAllapotDisabled, rendelesAllapotOptions,

}) => {
  const { change } = useRFFormContext();
  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    change("eloszuresHelyszin", helyszinValue);
  }, [helyszinValue]);

  useEffect(() => {
    change("eloszuresKezdete", kezdeteValue);
  }, [kezdeteValue]);

  useEffect(() => {
    change("eloszuresVege", vegeValue);
  }, [vegeValue]);

  useEffect(() => {
    change("eloszuresKereses", keresesValue);
  }, [keresesValue]);

  useEffect(() => {
    change("keresesType", keresesTypeValue);
  }, [keresesTypeValue]);

  useEffect(() => {
    change("eloszuresFizKezdete", fizKezdeteValue);
  }, [fizKezdeteValue]);

  useEffect(() => {
    change("eloszuresFizVege", fizVegeValue);
  }, [fizVegeValue]);

  useEffect(() => {
    change("eloszuresEloadas", eloadasValue);
  }, [eloadasValue]);

  useEffect(() => {
    change("eloszuresFizetesimod", fizetesiModValue);
  }, [fizetesiModValue]);

  useEffect(() => {
    change("eloszuresRendelesTipus", rendelesTipusValue);
  }, [rendelesTipusValue]);

  useEffect(() => {
    change("eloszuresRendelesAllapot", rendelesAllapotValue);
  }, [rendelesAllapotValue]);
  
  return (
    <React.Fragment>
      <div className='row'>
        <div className="col-md-6">
          <RFField
            type="select"
            name="eloszuresHelyszin"
            id="eloszuresHelyszin"
            label="Helyszín: "
            value={helyszinValue}
            onChange={helyszinOnChange}
            disabled={helyszinDisabled}
            defaultSelect={<option value="">Válassz helyszínt...</option>}
            selectOptions={helyszinOptions}
          />
        </div>
        <div className="col-md-3">
          <DatetimePicker
            name="eloszuresKezdete"
            id="eloszuresKezdete"
            label={<>Esemény kezdete (-tól):<CustomTooltip text={getTooltip('esemeny')} id="eloszuresKezdeteTolTT" /></>}
            value={kezdeteValue}
            onChange={(e, v) => datumOnChange(e, v, 'eloszuresKezdete')}
            containerClassName="organw-date-time"
            time={false}
            messages={{ dateButton: 'dátum', timeButton: 'idő' }}
          />
        </div>
        <div className="col-md-3">
          <DatetimePicker
            name="eloszuresVege"
            id="eloszuresVege"
            label={<>Esemény kezdete (-ig):<CustomTooltip text={getTooltip('esemeny')} id="eloszuresKezdeteIgTT" /></>}
            value={vegeValue}
            onChange={(e, v) => datumOnChange(e, v, 'eloszuresVege')}
            containerClassName="organw-date-time"
            time={false}
            messages={{ dateButton: 'dátum', timeButton: 'idő' }}
          />
        </div>
      </div>
      <div className='row'>
          <div className="col-md-4">
            <RFField
              name="eloszuresKereses"
              id="eloszuresKereses"
              label="Összetett keresés:"
              value={keresesValue}
              onChange={keresesOnChange}
            />
          </div>
          <div className="col-md-2">
            <fieldset
              name="keresesType"
              id="rendeles-kereses-tipus"
              required
              errorMessage="Kötelező mező!"
              style={{ marginTop: 21 }}
              value={keresesTypeValue}
              onChange={keresesTypeOnChange}
            >
              <RFField type='radio' name='rendelestipus' label="Rendelésszám" value="RENDELES" checked={keresesTypeValue === 'RENDELES'} />
              <RFField type='radio' name='rendelestipus' label="Név-email" value="NEVMAIL" checked={keresesTypeValue === 'NEVMAIL'} />
            </fieldset>
          </div>
          <div className="col-md-4">
            <RFField
              type="select"
              name="eloszuresEloadas"
              id="eloszuresEloadas"
              label="Esemény:"
              value={eloadasValue}
              onChange={handleInputChange}
              disabled={eloadasDisabled}
              errorMessage="Kötelező mező!"
              defaultSelect={<option value="">Válassz eseményt...</option>}
              selectOptions={eloadasOptions}
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="eloszuresRendelesTipus"
              id="eloszuresRendelesTipus"
              label="Rendelés típusa: "
              value={rendelesTipusValue}
              onChange={handleInputChange}
              disabled={rendelesTipusDisabled}
              errorMessage="Kötelező mező!"
              defaultSelect={<option value="">Válassz típust...</option>}
              selectOptions={rendelesTipusOptions}
            />
          </div>
      </div>
      
      <div className="row">
        <div className="col-md-12">
          <h4 onClick={() => { console.log('collapseee'); setCollapse(!collapse) }} style={{ cursor: 'pointer' }}>
            {'Keresés egyéb adatok alapján '}
            {<i className={collapse ? 'fa fa-caret-up' : 'fa fa-caret-down'} />}
          </h4>
        </div>
        <div className="col-md-12">
          <Collapse isOpen={collapse}>
            <div className="row">
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="eloszuresRendelesAllapot"
                  id="eloszuresRendelesAllapot"
                  label="Rendelés állapota: "
                  value={rendelesAllapotValue}
                  onChange={handleInputChange}
                  disabled={rendelesAllapotDisabled}
                  errorMessage="Kötelező mező!"
                  defaultSelect={<option value="">Válassz állapotot...</option>}
                  selectOptions={rendelesAllapotOptions}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  type="select"
                  name="eloszuresFizetesimod"
                  id="eloszuresFizetesimod"
                  label="Fizetési mód:"
                  value={fizetesiModValue}
                  onChange={handleInputChange}
                  disabled={fizetesiModDisabled}
                  errorMessage="Kötelező mező!"
                  defaultSelect={<option value="">Válassz fizetési módot...</option>}
                  selectOptions={fizetesiModOptions}
                />
              </div>
              <div className="col-md-3">
                <DatetimePicker
                  name="eloszuresFizKezdete"
                  id="eloszuresFizKezdete"
                  label="Fizetés dátuma (-tól):"
                  value={fizKezdeteValue}
                  onChange={(e, v) => fizDatumOnChange(e, v, 'eloszuresFizKezdete')}
                  containerClassName="organw-date-time"
                  time={false}
                  messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                  disabled={datumDisabled}
                />
              </div>
              <div className="col-md-3">
                <DatetimePicker
                  name="eloszuresFizVege"
                  id="eloszuresFizVege"
                  label="Fizetés dátuma (-ig):"
                  value={fizVegeValue}
                  onChange={(e, v) => fizDatumOnChange(e, v, 'eloszuresFizVege')}
                  disabled={datumDisabled}
                  containerClassName="organw-date-time"
                  time={false}
                  messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                />
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RendelesEloszures;
